// extracted by mini-css-extract-plugin
module.exports = {"info":"b429494557--info--JAvte","data":"b429494557--data--Nd83q","logo":"b429494557--logo--my1AX"};